"use client";

import { useFormStatus } from "react-dom";

import { Button } from "@/components/button/button.component";
import { Loader } from "@/components/loader/loader.component";

import { GetProductQueryResult } from "@/sanity.types";

export const ProductActionsAccessory = ({
  product,
}: ProductActionsAccessoryProps) => {
  const { pending } = useFormStatus();
  if (!product?.id || product.type !== "accessory") return null;
  return (
    <section
      data-testid="product-actions-accessory"
      className="flex flex-col gap-4">
      <div className="flex justify-center gap-4 lg:justify-start">
        <input
          id="accessory-id"
          type="hidden"
          name="accessoryId"
          defaultValue={product.id}
        />
        <Button
          data-testid="product-actions-accessory-add-to-cart"
          secondary
          className="w-full cursor-pointer md:w-1/2"
          type="submit"
          disabled={pending}>
          Build My System
          <Loader
            loading={pending}
            size="sm"
            data-testid="product-actions-accessory-loader"
          />
        </Button>
      </div>
    </section>
  );
};

export type ProductActionsAccessoryProps = {
  product: GetProductQueryResult;
};
